import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { TextField as MuiTextField } from "final-form-material-ui";

const TextFieldStyles = {
    root: {
        "& p": {
            // position:"absolute",
            top: "50px",
            textAlign: "right",
            display: "block",
            width: "100%"
        }
    },
    inputRoot: {
        fontSize: "1.2rem",
        background: "#F7FAFC",
        borderRadius: "10px",
        color: "#153862",
        // overflow: 'hidden',
        "& input": {
            borderRadius: "10px",
            padding: "10px",
            height: "32px"
        }
    },
    error: {
        border: "2px solid #FF0C0C"
    }
};
const TextField = props => {
    const { classes, InputProps, dataTestId, ...rest } = props;

    return (
        <MuiTextField
            {...rest}
            className={classes.root}
            InputProps={{
                disableUnderline: true,
                classes: {
                    error: classes.error,
                    root: classes.inputRoot
                },
                "data-testid": dataTestId,
                ...InputProps
            }}
            FormHelperTextProps={{
                "data-testid": `error_${dataTestId}`
            }}
        />
    );
};

export default withStyles(TextFieldStyles)(TextField);



// WEBPACK FOOTER //
// ./src/components/StartContainer/components/TextField.js